module.exports = __webpack_public_path__ + "img/full4-min.6dee8756.png";